import { url_dev , url_production } from '@/api/config';

const deviceType = IsPC()?'pc':'mobile'
const host = process.env.NODE_ENV == 'development' ? url_dev : url_production;
const webUrl = process.env.NODE_ENV == 'development' ? location.origin + '/' : 'https://www.m3guo.com/activity/202511/w11-ja0f7/';
const domain = deviceType == 'pc' ? webUrl + 'index.html' : webUrl + 'index.html';
//const domain = webUrl + 'index.html';

const activityTime = '4月25日-5月10日';

const getQueryVariable = function (variable) {
    var query = window.location.search.substring(1) || window.location.hash.substring(1);
    //console.log(window.location.hash);
    var vars = query.split("&");

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
        return pair[1];
        }
    }
    return '';
}


const isDataEmpty = (obj) => {
  return Object.keys(obj).length === 0;
}

const wx_share_text = {
 title: '双11狂欢节', // 分享标题
  desc: '10月30日-11月12日 双11狂欢节来袭，自选宝库、百亿补贴、狂欢商店，好物等你拿！', // 分享描述
  imgUrl: 'https://web-resource.17m3.com/m3guo/202511/w11/300300.jpg', // 分享图标   
}

const issn = '51';

const ajax_url_map = {
  login : host + '/api/login/authorize?callbackurl=' + encodeURIComponent(domain) + '&issn=' + issn,
  logout : '',
  task_share : host + '/api/share/getCode',
  free: host + '/api/login/kouDai', //口袋自登录验证  
  mplat : host + '/api/login/mplat',//梦平台免登录
  tips : 'https://tool.m3guo.com/api/web/m3goods/eq-item/',//tip获取
}

const cleanArray = function (actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

const formatNum = function (val,max) {
  return Math.min(val,max);
}

const param =  function (json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined)
      return ''
    return encodeURIComponent(key) +
    '=' + encodeURIComponent(json[key])
  })).join('&')
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
      }
  }
  return flag;
}

const areaList = [{
  "id": 1,
  "name": "火烧赤壁"
}, {
  "id": 2,
  "name": "草船借箭"
}, {
  "id": 6,
  "name": "荆州之战"
}, {
  "id": 7,
  "name": "青梅煮酒"
}, {
  "id": 11,
  "name": "九伐中原"
}, {
  "id": 16,
  "name": "怀旧服"
}, {
  "id": 8,
  "name": "官渡之战"
}, {
  "id": 9,
  "name": "桃园结义"
}, {
  "id": 19,
  "name": "火凤燎原"
}, {
  "id": 20,
  "name": "卧龙出渊"
},
{
  "id": 21,
  "name": "长生殿(Steam)"
}, 
{
  "id": 17,
  "name": "铜雀台(wegame1)"
}, {
  "id": 18,
  "name": "凤仪亭(wegame2)"
}, {
  "id": 100,
  "name": "TEST_1"
}, {
  "id": 110,
  "name": "TEST_2"
}
]

const queryArea = function (num){
  var area = '暂无大区信息';

  if (num == 1) {
      area = '火烧赤壁';
  } else if (num == 2) {
      area = '草船借箭';
  } else if (num == 6) {
      area = '荆州之战';
  } else if (num == 7) {
      area = '青梅煮酒';
  } else if (num == 8) {
      area = '官渡之战';
  } else if (num == 9) {
      area = '桃园结义';
  } else if (num == 11) {
      area = '九伐中原';
  } else if (num == 12) {
      area = '逐鹿中原';
  } else if (num == 13) {
      area = '三分天下';
  } else if (num == 16) {
      area = '怀旧服';
  }else if (num == 17) {
      area = '铜雀台';
  } else if (num == 18) {
      area = '凤仪亭';
  }else if (num == 19) {
      area = '火凤燎原';
  }else if (num == 20) {
      area = '卧龙出渊';
  }else if (num == 21) {
      area = '长生殿';
  }else if (num == 100 || num == 101) {
      area = '测试大区';
  }

  return area;
}

const share_format = function(data){
  return data.koudai + '阿斗测试分享' + data.shopName + ' '  + data.price + ' ' + data.url;
};

const max_format = function(max,n = 0){
  return Math.min(n,max);
}

const isIos = function () {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}();


const getIOSVersion = function() {
    const userAgent = navigator.userAgent;
    const match = userAgent.match(/(iPhone|iPad|iPod)\sOS\s([\d_]+)/);
    if (match) {
        return match[2].replace(/_/g, '.');
    }
    return '';
}

// 检测 iPhone 是否有灵动岛（Dynamic Island）
const isDynamicIsland = function() {
  // 只在 iPhone 上继续判断
  const isIPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
  if (!isIPhone) return false;

  // 通过 safe-area-inset-top（env）获取安全区顶部高度
  try {
    const probe = document.createElement('div');
    probe.style.cssText = 'position:fixed;top:0;left:0;visibility:hidden;padding-top:env(safe-area-inset-top);';
    document.body.appendChild(probe);
    const computed = parseFloat(getComputedStyle(probe).paddingTop) || 0;
    document.body.removeChild(probe);

    // 灵动岛机型在竖屏下 safe-area-inset-top 常比普通刘海更高，经验值可设为 59px
    if (computed >= 59) return true;
  } catch (e) {
    // ignore
  }

  // 兜底：部分浏览器/环境不支持 env()，可用 UA + 屏幕尺寸进一步判断（非万无一失）
  const w = Math.max(window.screen.width, window.screen.height);
  const h = Math.min(window.screen.width, window.screen.height);
  const dpr = window.devicePixelRatio || 1;

  // 示例兜底条件（可按需扩展/调整）
  // iPhone 14 Pro / 14 Pro Max 等常见灵动岛机型的 CSS 尺寸通常较大
  if (dpr >= 3 && (w >= 852 || h >= 852)) return true;

  return false;
}

export default {
    ajax_url_map,
    getQueryVariable,
    domain,
    param,
    deviceType,
    areaList,
    issn,
    wx_share_text,
    queryArea,
    formatNum,
    activityTime,
    share_format,
    max_format,
    isIos,
    isDataEmpty,
    getIOSVersion,
    isDynamicIsland,
    // 添加：获取灵动岛（safe-area-inset-top）高度（返回 Number，单位 px）
    getDynamicIslandHeight() {
      // 只对 iPhone 有意义
      if (!/iphone/i.test(navigator.userAgent)) return 0;
      try {
        const probe = document.createElement('div');
        probe.style.cssText = 'position:fixed;top:0;left:0;visibility:hidden;padding-top:env(safe-area-inset-top);';
        document.body.appendChild(probe);
        const value = parseFloat(getComputedStyle(probe).paddingTop) || 0;
        document.body.removeChild(probe);
        // 有时 env 返回的是较小值（刘海机型 ~44px，灵动岛机型 ~59px），直接返回数值
        return value;
      } catch (e) {
        return 0;
      }
    }
}